<template>
  <div class="updating-wrap">
    <!--
    <img class="img" v-for="item in 15" :key="item" :src="'https://cdn.spbcn.org/IZONE/'+ (item-1) +'.png'" alt="">
    -->
    <div class="updating-card" role="status" aria-live="polite">
      <div class="updating-icon-wrap" aria-hidden="true">
        <i class="el-icon-goods updating-icon-main"></i>
        <span class="updating-icon-badge">
          <i class="el-icon-loading updating-icon-spin"></i>
        </span>
      </div>
      <h1 class="updating-title">商品更新中</h1>
      <p class="updating-desc">
        <i class="el-icon-time updating-inline-icon"></i>
        敬请期待，我们正在准备更多精彩内容
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  created () {
    document.title = 'IZON爱眼尊'
  }
}
</script>
<style scoped>
.img{
  width: 100%;
  display: block;
}

.updating-wrap{
  box-sizing: border-box;
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 20px;
  padding-bottom: calc(24px + env(safe-area-inset-bottom, 0px));
  padding-top: calc(24px + env(safe-area-inset-top, 0px));
  background: linear-gradient(165deg, #2a2a2a 0%, #1a1a1a 55%, #333 100%);
}

.updating-card{
  width: 100%;
  max-width: 420px;
  text-align: center;
}

.updating-icon-wrap{
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}

.updating-icon-main{
  font-size: 102px;
  color: rgba(255, 255, 255, 0.92);
  line-height: 1;
}

.updating-icon-badge{
  position: absolute;
  right: -6px;
  bottom: 4px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
}

.updating-icon-spin{
  font-size: 24px;
  color: #e6a23c;
  animation: updating-spin 1.1s linear infinite;
}

@keyframes updating-spin{
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.updating-title{
  margin: 0 0 14px;
  color: #fff;
  font-size: clamp(26px, 7.2vw, 36px);
  font-weight: 600;
  letter-spacing: 0.5px;
  line-height: 1.35;
}

.updating-desc{
  margin: 0;
  color: rgba(255, 255, 255, 0.72);
  font-size: clamp(18px, 5vw, 21px);
  line-height: 1.55;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;
  text-align: left;
  max-width: 340px;
  margin-left: auto;
  margin-right: auto;
}

.updating-inline-icon{
  flex-shrink: 0;
  margin-top: 3px;
  font-size: 21px;
  color: rgba(255, 255, 255, 0.55);
}

@media (max-width: 360px){
  .updating-wrap{
    padding-left: 16px;
    padding-right: 16px;
  }

  .updating-icon-main{
    font-size: 90px;
  }

  .updating-desc{
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 8px;
  }

  .updating-inline-icon{
    margin-top: 0;
  }
}
</style>
